import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';
import { ConnectedPhasesTypeEnum, PhasesTypeEnum } from './grid-registration.enum';

export { PhasesTypeEnum } from './grid-registration.enum';

/** String values match backend PowerInverterTypeEnum (JPA STRING). */
export enum PowerInverterTypeEnum {
  Battery = 'Battery',
  Hybrid = 'Hybrid'
}

export type PowerInverterType = `${PowerInverterTypeEnum}`;

export const PowerInverterTypeDisplayNames: Record<PowerInverterType, string> = {
  [PowerInverterTypeEnum.Battery]: 'Batterie',
  [PowerInverterTypeEnum.Hybrid]: 'Hybrid'
};

export class ProducerModel {
  id: string;
  manufacturer: string;
  deviceTypeName: string;
  count: number; // units
  acActivePowerMax: number;
  dischargePower?: number;
  acApparentPowerMax: number;
  phases?: PhasesType;
  connectedPhases: number;
  maStRNumber?: string;
  zerezId?: string;
  /** Speicher als Erzeuger: Anbindung an vorhandenen vs. neuen Wechselrichter */
  isExistingPowerInverter?: boolean;
  powerInverterType?: PowerInverterType;
}

export type ProducerForm = TypedForm<ProducerModel>;

export type PhasesType = `${PhasesTypeEnum}`;

export const PhasesTypeDisplayNames: Record<PhasesTypeEnum, string> = {
  [PhasesTypeEnum.L1]: '1',
  [PhasesTypeEnum.L2]: '2',
  [PhasesTypeEnum.L3]: '3'
};

export type ConnectedPhasesType = `${ConnectedPhasesTypeEnum}`;

export const ConnectedPhasesTypeDisplayNames: Record<ConnectedPhasesType, string> = {
  [ConnectedPhasesTypeEnum.L1]: 'L1',
  [ConnectedPhasesTypeEnum.L2]: 'L2',
  [ConnectedPhasesTypeEnum.L3]: 'L3',
  [ConnectedPhasesTypeEnum.L1L2]: 'L1, L2',
  [ConnectedPhasesTypeEnum.L1L3]: 'L1, L3',
  [ConnectedPhasesTypeEnum.L2L3]: 'L2, L3',
  [ConnectedPhasesTypeEnum.L1L2L3]: 'L1, L2, L3'
};
